import i18n from 'i18next'
import { toast } from 'react-toastify'
import ExchangeRateUnavailableError from '../models/ExchangeRateUnavailableError'

export default function notifyExchangeRateError(error: unknown): void {
  if (error instanceof ExchangeRateUnavailableError) {
    toast.error(
      i18n.t<string>('messages.exchangeRateUnavailable', { currency: error.currency }),
      { toastId: `exchange-rate-unavailable-${error.currency}` },
    )
    return
  }
  toast.error(i18n.t<string>('common.error'))
}
